import React from "react";
import { HashLink } from "react-router-hash-link";
import {
  TwitterShareButton,
  LineShareButton,
  TwitterIcon,
  LineIcon,
} from "react-share";

import doshin from "../images/doshin.jpg";
import careerBank from "../images/careerBank.png";
import iwaizumi from "../images/iwaizumi.jpg";
import toTop from "../images/toTop.svg";

const Footer = () => {
  return (
    <footer>
      <HashLink smooth to="#top">
        <img src={toTop} alt="" className="toTop" />
      </HashLink>
      <ul className="sitemap">
        <li>
          <HashLink smooth to="#top">
            道新適職フェア
          </HashLink>
        </li>
        <li>
          <HashLink smooth to="#howto">
            参加方法
          </HashLink>
        </li>
        <li>
          <HashLink smooth to="#joblist">
            求人一覧
          </HashLink>
        </li>
        <li>
          <HashLink smooth to="#place">
            開催会場
          </HashLink>
        </li>
        <li>
          <HashLink smooth to="#infection">
            感染対策について
          </HashLink>
        </li>
        <li>
          <HashLink smooth to="#contact">
            お問い合わせ
          </HashLink>
        </li>
      </ul>
      <div className="footer-flex">
        <p>
          <a
            href="https://www.hokkaido-np.co.jp/privacy/"
            target="_blank"
            rel="noreferrer"
          >
            個人情報保護方針<i className="fas fa-chevron-right"></i>
          </a>
        </p>
        <ul className="shareButton">
          <li>SHARE</li>
          <li>
            <TwitterShareButton
              title="【北海道・札幌の求人】6月26日開催！お仕事探しなら道新適職フェア。"
              url="https://tekisyoku-fair.web.app/"
            >
              <TwitterIcon size={32} round={true} />
            </TwitterShareButton>
          </li>
          <li>
            <LineShareButton
              title="【北海道・札幌の求人】6月26日開催！お仕事探しなら道新適職フェア。"
              url="https://tekisyoku-fair.web.app/"
            >
              <LineIcon size={32} round={true} />
            </LineShareButton>
          </li>
        </ul>
      </div>
      <div className="event-info-flex">
        <div>
          <p className="event-info-title">■主催</p>
          <a
            href="https://www.hokkaido-np.co.jp/"
            target="_blank"
            rel="noreferrer"
          >
            <img src={doshin} alt="北海道新聞社" />
          </a>
          <p className="companyName">北海道新聞社</p>
        </div>
        <div>
          <p className="event-info-title">■特別協力</p>
          <a
            href="https://www.career-bank.co.jp/"
            target="_blank"
            rel="noreferrer"
          >
            <img src={careerBank} alt="career bank" />
          </a>
          <p className="companyName">キャリアバンク株式会社</p>
        </div>

        <div>
          <p className="event-info-title">■運営事務局</p>
          <a
            href="https://www.iwaizumi.co.jp/"
            target="_blank"
            rel="noreferrer"
          >
            <img src={iwaizumi} alt="iwaizumi" />
          </a>
          <p className="companyName">株式会社アド・ビューロー岩泉</p>
        </div>
        <div className="telAndMail">
          <p>
            TEL:<a href="tel:011-727-6001">011-727-6001</a>
          </p>
          <p>
            Email:
            <a href="mailto:do-tekisyoku@iwaizumi.co.jp">
              do-tekisyoku@iwaizumi.co.jp
            </a>
          </p>
        </div>
      </div>

      <small>©︎2020 The Hokkaido Shimbun Press.</small>
    </footer>
  );
};

export default Footer;
